import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContModulosSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0px 0 60px 0;
  max-width: 1440px;
  margin: 0 auto;

  @media(min-width: 300px) and (max-width: 767px){
    padding: 0px 0px 0px 0;
  }
`;

export const TitleModulos = styled.h2`
  font-family: ${GlobalFonts.fontBold};
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  color: ${GlobalColors.colorText};
  margin-bottom: 20px;
  width: 80%;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 32px;
    line-height: 40px;
    width: 90%;
  }
`;

export const DescModulos = styled.p`
  font-family: ${GlobalFonts.fontRegular};
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: ${GlobalColors.colorText};
  margin-bottom: 50px;
  width: 70%;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 16px;
    line-height: 24px;
    width: 90%;
    margin-bottom: 30px;
  }
`;

export const ModulosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px 50px;
  width: 95%;
  margin-bottom: 20px;

  @media(min-width: 300px) and (max-width: 767px){
    grid-template-columns: repeat(2, 1fr);
    width: 90%;
    gap: 15px;
  }

  @media(min-width: 768px) and (max-width: 1023px){
    grid-template-columns: repeat(3, 1fr);
    width: 90%;
  }

  @media(min-width: 1024px) and (max-width: 1279px){
    grid-template-columns: repeat(4, 1fr);
    width: 90%;
  }
`;

export const ModuloCard = styled.div`
  background: #D0E5FD;
  border-radius: 16px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(91, 141, 238, 0.2);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(91, 141, 238, 0.15);
    border-color: ${GlobalColors.colorPrimary};
  }

  @media(min-width: 300px) and (max-width: 767px){
    padding: 20px 15px;
  }
`;

export const ModuloIcon = styled.div`
  width: 60px;
  height: 60px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media(min-width: 300px) and (max-width: 767px){
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
  }
`;

export const ModuloTitle = styled.h3`
  font-family: ${GlobalFonts.fontBold};
  font-size: 16px;
  line-height: 22px;
  color: ${GlobalColors.colorText};
  margin: 0;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 14px;
    line-height: 20px;
  }
`;
